import { useState } from 'react';
import * as XLSX from 'xlsx';
import { Heading, Avatar } from '@vibe/core';
import { File as FileIcon, Table as TableIcon, Check as CheckIcon } from '@vibe/icons';
import { fileToWorkbook } from '../services/converter';

type FilePickerProps = {
  format: boolean | null;
  onChange: (workbook: XLSX.WorkBook | null) => void;
  onError: (error: Error) => void;
};

function SpreadsheetPicker({ format, onChange, onError }: FilePickerProps) {
  const [file, setFile] = useState<string | undefined>(undefined);

  return (
    <div className="SpreadsheetPicker-Wrapper">
      <label className="SpreadsheetPicker-Label" htmlFor="monday_excel">
        <div className="SpreadsheetPicker-Avatar">
          <Avatar size="large" type="icon" icon={format ? CheckIcon : TableIcon} customBackgroundColor="#0073ea" withoutBorder square />
        </div>
        <div className="SpreadsheetPicker-Headline">
          {format ? (
            <>
              <Heading type="h3" align="center" style={{ color: '#0073ea' }}>
                {file}
              </Heading>
              <span className="SpreadsheetPicker-Text">
                Click the file format below into which you <br />
                want to convert the selected Excel file.
              </span>
            </>
          ) : (
            <>
              <Heading type="h3" align="center" style={{ color: '#0073ea' }}>
                Choose file
              </Heading>
              <span className="SpreadsheetPicker-Text">
                Select your exported Excel file <br />
                from monday.com to convert.
              </span>
            </>
          )}
        </div>
      </label>
      <div
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          opacity: 0,
        }}
      >
        <input
          id="monday_excel"
          type="file"
          accept=".xlsx"
          onChange={async (ev) => {
            let file: File | null = null;
            try {
              if (ev.target.files && ev.target.files.length > 0) {
                file = ev.target.files[0];
                const workbook = await fileToWorkbook(ev.target.files[0]);
                onChange(workbook);
                setFile(ev.target.files[0].name);
              } else {
                onError(
                  new Error(
                    'The file could not be loaded or no file was selected. If you did select a file, this error might occur because of browser restrictions.',
                  ),
                );
                return;
              }
            } catch (err) {
              if (err instanceof Error && err.message) {
                if (file && file?.size) {
                  err.message = `Error processing file (size: ${file.size} bytes) -- ${err.message}`;
                } else {
                  err.message = `Error processing file -- ${err.message}`;
                }

                onError(err);
                return;
              } else {
                onError(err as any);
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default SpreadsheetPicker;
